module.exports = __webpack_public_path__ + "static/img/1062_big.bc08b94.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1062_big.png
// module id = bo29
// module chunks = 1